(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('shareMapper', shareMapper);

	function shareMapper(_, uriUtility) {
		function mapShare(source) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(mapShare);

			return {
				id: source.id,
				token: source.token,
				assetId: source.assetId,
				shareUrl: uriUtility.fromPattern('/shares/{token}', { token: source.token })
			};
		}

		return {
			map: mapShare
		};
	}
	shareMapper.$inject = ['_', 'uriUtility'];
})();